import styled from "styled-components"

export const FooterWrapper = styled.div`  
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-position: 0px -50px;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 0px 0;
  background: linear-gradient(156deg, #003283 7%, #28c973 86%);
  position: relative;
  padding-top:80px;

    .page-footer{
      width: 90%;

      .container-fluid{
          padding: 0;
      }
      .row {
        --bs-gutter-x: 5.5rem;
      }
      .footer-description{
          color: #fff;
          font-size: 14px;
          line-height:22px;
      }
      .logo-icon{
          margin-bottom:0;
      }
      h5{
        color: #f8f8f873;
        font-size: 16px;
        line-height: 22px;
        text-transform: uppercase;
        margin-bottom: 20px;
      }

      ul{
          margin:0;
        
        li{
            margin-bottom: 5px;
        }
        a{
            color: #fff;
            font-size: 14px;
            line-height:22px;
            text-decoration: none;
            display: block;
        }

        p{
          color: #fff;
          font-size: 14px;
          line-height:22px;
          text-decoration: none;
          display: block;
        }
      }
      .follow-us-list li{
          display: inline-block;
          padding: 0 8px;
        svg{
          font-size: 22px;
        }
      }
      .app-icon {
        a{
            max-width: 160px !important;
        margin: 0 0 10px 0;
        display: block;
          }
          img{
            filter: invert(1);
          }
      }
      .footer-copyright {
        padding-top: 2em;
        padding-bottom: 1.66666em;
        border-top: 1px solid #033d8224;
        margin-top: 1em;
          
        p{
            color: #fff;
            font-size: 14px;
            line-height: 22px;
          }
      }
    }
`